import React from 'react';
import { Box, Button, Typography, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Logo from '../../assets/logo.png';
import HeroCanvas from './HeroCanvas';

const HeroSection: React.FC = () => {
  const navigate = useNavigate();
  return (
    <Box sx={{
      position: 'relative',
      color: 'white',
      py: 8,
      textAlign: 'center',
      boxShadow: 3,
      mb: 4,
      minHeight: 400,
      backgroundColor: 'transparent',
    }}>
      {/* Background image behind HeroCanvas */}
      <Box sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 0,
        backgroundImage: `url(${require('../../assets/background2.jpg')})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        opacity: 0.9,
        pointerEvents: 'none',
      }} />
      {/* HeroCanvas above background */}
      <Box sx={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 1 }}>
        <HeroCanvas />
      </Box>
      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 2 }}>
        <img src={Logo} alt="SyrDevUae Logo" style={{ width: 220, marginBottom: 24, display: 'block', marginLeft: 'auto', marginRight: 'auto' }} />
        <Typography variant="h2" fontWeight={700} gutterBottom>
          Welcome to SyrDevUae
        </Typography>
        <Typography variant="h5" color="rgba(255,255,255,0.85)" gutterBottom>
          Elite Membership Knowledge Center
        </Typography>
        <Typography variant="body1" color="rgba(255,255,255,0.85)" sx={{ mb: 4 }}>
          Empowering the Syrian developer community in the UAE and beyond.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          size="large"
          sx={{ fontWeight: 700, px: 5, py: 1.5, fontSize: 20, marginBottom: 10 }}
          onClick={() => navigate('/join')}
        >
          Join Now
        </Button>
      </Container>
    </Box>
  );
};

export default HeroSection; 